/**
 * Static Pages Template JavaScript
 * 
 * Handles the functionality for the static pages tabs navigation
 */


document.addEventListener('DOMContentLoaded', function() {
  // Get DOM elements
  const tabsContainer = document.querySelector('.static-pages-menu');
  const prevButton = document.querySelector('.prev-arrow');
  const nextButton = document.querySelector('.next-arrow');
  const pageContentContainer = document.querySelector('.page-content-container');
  const contentLoader = document.querySelector('.content-loader');
  
  // Get current site hostname
  const currentHostname = window.location.hostname;
  
  // Hide loader initially after content is loaded
  if (contentLoader) {
    window.addEventListener('load', function() {
      contentLoader.style.display = 'none';
    });
  }
  
  // Initialize tab navigation if elements exist
  if (tabsContainer && prevButton && nextButton) {
    // Enable horizontal scrolling on the tabs containers
    tabsContainer.style.overflowX = 'auto';
    
    // Set up scroll buttons
    prevButton.addEventListener('click', function(e) {
      e.preventDefault();
      tabsContainer.scrollBy({ left: -200, behavior: 'smooth' });
    });
    
    nextButton.addEventListener('click', function(e) {
      e.preventDefault();
      tabsContainer.scrollBy({ left: 200, behavior: 'smooth' });
    });
    
    // Scroll active tab into view on page load
    const activeTab = tabsContainer.querySelector('.active');
    if (activeTab) {
      centerActiveTab(activeTab);
    }
    
    // Handle tab visibility for arrows
    function updateArrowVisibility() {
      // Check if scroll is at the beginning
      if (tabsContainer.scrollLeft <= 10) {
        prevButton.classList.add('hidden');
      } else {
        prevButton.classList.remove('hidden');
      }
      
      // Check if scroll is at the end
      const scrollableWidth = tabsContainer.scrollWidth - tabsContainer.clientWidth;
      if (tabsContainer.scrollLeft >= scrollableWidth - 10) {
        nextButton.classList.add('hidden');
      } else {
        nextButton.classList.remove('hidden');
      }
    }
    
    // Add scroll event listener to update arrow visibility
    tabsContainer.addEventListener('scroll', updateArrowVisibility);
    
    // Call once on page load
    updateArrowVisibility();
    
    // Handle window resize
    window.addEventListener('resize', function() {
      // Update arrow visibility when window is resized
      updateArrowVisibility();
      
      // Re-center active tab when window is resized
      const activeTab = tabsContainer.querySelector('.active');
      if (activeTab) {
        activeTab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    });
    
    // Helper function to check if URL is external
    function isExternalURL(url) {
      try {
        const urlObj = new URL(url);
        return urlObj.hostname !== currentHostname;
      } catch (e) {
        return false; // Invalid URL, assume internal
      }
    }
    
    // Function to center the active tab
    function centerActiveTab(tab) {
      const containerWidth = tabsContainer.clientWidth;
      const tabWidth = tab.offsetWidth;
      const tabOffsetLeft = tab.offsetLeft;
      const scrollLeft = tabOffsetLeft - (containerWidth / 2) + (tabWidth / 2);
      tabsContainer.scrollTo({ left: scrollLeft, behavior: 'smooth' });
    }
    
    // Handle tab clicks to load content via AJAX
    const tabLinks = tabsContainer.querySelectorAll('a');
    tabLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        // Get the URL from the link
        const url = this.getAttribute('href');
        
        // Check if the URL is external
        if (isExternalURL(url)) {
          // For external links, just navigate normally
          window.location.href = url;
          return; // Exit the function early
        }
        
        // For internal links, prevent default and use AJAX
        e.preventDefault();
        
        // Update browser history without reloading
        window.history.pushState({path: url}, '', url);
        
        // Remove active class from all tabs
        tabLinks.forEach(tab => tab.classList.remove('active'));
        
        // Add active class to clicked tab
        this.classList.add('active');
        
        // Center the active tab
        centerActiveTab(this);
        
        // Show loading state
        if (pageContentContainer) {
          pageContentContainer.classList.add('loading');
          
          // Show loader
          if (contentLoader) {
            contentLoader.style.display = 'flex';
          }
          
          // Hide content while loading
          const pageTitle = pageContentContainer.querySelector('.page-title');
          const pageContent = pageContentContainer.querySelector('.page-content');
          
          if (pageTitle) pageTitle.style.opacity = '0.3';
          if (pageContent) pageContent.style.opacity = '0.3';
        }
        
        // Fetch the content from the page
        fetch(url)
          .then(response => response.text())
          .then(html => {
            // Create a temporary element to parse the HTML
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            // Extract the page title and content
            const newTitle = doc.querySelector('.page-title');
            const newContent = doc.querySelector('.page-content');
            
            // Update the page content
            if (pageContentContainer) {
              const pageTitle = pageContentContainer.querySelector('.page-title');
              const pageContent = pageContentContainer.querySelector('.page-content');
              
              if (pageTitle && newTitle) {
                pageTitle.innerHTML = newTitle.innerHTML;
              }
              
              if (pageContent && newContent) {
                pageContent.innerHTML = newContent.innerHTML;
              }
              
              // Update document title
              document.title = doc.title;
              
              // Short delay to ensure content is ready before hiding loader
              setTimeout(() => {
                // Hide loader
                if (contentLoader) {
                  contentLoader.style.display = 'none';
                }
                
                // Restore content visibility
                if (pageTitle) pageTitle.style.opacity = '1';
                if (pageContent) pageContent.style.opacity = '1';
                
                // Remove loading state
                pageContentContainer.classList.remove('loading');
              }, 300);
            }
          })
          .catch(error => {
            // console.error('Error loading page content:', error);
            
            // Hide loader on error
            if (contentLoader) {
              contentLoader.style.display = 'none';
            }
            
            // Restore content visibility on error
            const pageTitle = pageContentContainer.querySelector('.page-title');
            const pageContent = pageContentContainer.querySelector('.page-content');
            
            if (pageTitle) pageTitle.style.opacity = '1';
            if (pageContent) pageContent.style.opacity = '1';
            
            // Remove loading state on error
            if (pageContentContainer) {
              pageContentContainer.classList.remove('loading');
            }
          });
      });
    });
    
    // Handle browser back/forward buttons
    window.addEventListener('popstate', function(e) {
      // Get the current URL
      const currentUrl = window.location.href;
      
      // Check if the current URL is external
      if (isExternalURL(currentUrl)) {
        // For external URLs, just navigate normally
        window.location.href = currentUrl;
        return;
      }
      
      // Find the tab that matches the current URL
      const matchingTab = Array.from(tabLinks).find(tab => tab.href === currentUrl);
      
      if (matchingTab) {
        // Simulate a click on the matching tab
        matchingTab.click();
      } else {
        // If no matching tab is found, reload the page
        window.location.reload();
      }
    });
  }
});